import {ExpirationRule} from './types';

export const validateExpirationRule = <
	T extends ExpirationRule = ExpirationRule,
>(
	rule: T,
) => {
	return true;
};

export default validateExpirationRule;
